import { Grid, Paper } from '@material-ui/core'
import { Fragment } from 'react'
import { Step1Props } from '../../../../../types/steps'
import ApartmentClientInformationForm from '../../../Forms/ApartmentClientInformationForm'
import { getClientInitialValues } from '../../../Forms/values/apartmentInitialValues'

const Step1Client = ({
  baseFormStepProps: {
    currentStep,
    apartment,
    isAdmin,
    isConfirmed,
    doStepBack,
    isMobile
  },
  classes,
  updateApartmentClientInfo,
  updateApartmentClientInfoToOverview,
  clientContactInfo,
  areUsersLoading
}: Step1Props) => {
  return (
    <Fragment>
      {!areUsersLoading && apartment && currentStep === 12 && (
        <Grid container direction='row' alignItems='center' justify='center'>
          <Grid item sm={12} md={12}>
            <Paper
              style={{ boxShadow: 'none !important', margin: '0' }}
              className={classes.formPaper}
            >
              <ApartmentClientInformationForm
                initialValues={{
                  ...getClientInitialValues(
                    apartment?.client,
                    clientContactInfo
                  ),
                  promocode: apartment?.confirmation?.promocode || ''
                }}
                currentStep={currentStep}
                doStepBack={doStepBack}
                isMobile={isMobile}
                updateApartmentClientInformation={updateApartmentClientInfo}
                updateApartmentClientInformationToOverview={updateApartmentClientInfoToOverview}
                isDisabled={isConfirmed}
                isConfirmed={apartment.metadata.confirmed}
                isMarketing={apartment.metadata.marketing}
                classes={classes}
                apartment={apartment}
              />
            </Paper>
          </Grid>
        </Grid>
      )}
    </Fragment>
  )
}

export default Step1Client
